import HelpOutlineOutlined from "@mui/icons-material/HelpOutlineOutlined";
import { Box, IconButton, Popover, Typography } from "@mui/material";
import { MouseEvent, ReactNode, useCallback, useState } from "react";

export const InfoIconPopover = ({ content }: { content: ReactNode }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => setAnchorEl(null), []);

  return (
    <>
      <IconButton
        size="small"
        onMouseDown={(event) => event.stopPropagation()}
        onClick={handleOpen}
        sx={{ padding: 0, marginLeft: "4px", pointerEvents: "auto" }}
      >
        <HelpOutlineOutlined fontSize="small" color="disabled" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ padding: 1.5, maxWidth: 320 }}>
          {typeof content === "string" ? (
            <Typography variant="caption">{content}</Typography>
          ) : (
            <Typography variant="caption" component="div">
              {content}
            </Typography>
          )}
        </Box>
      </Popover>
    </>
  );
};
